import React from 'react';
import { FileStack } from 'lucide-react';
import PresentacionesTab from '../f8126/PresentacionesTab';

export default function KpisPresentaciones() {
  return (
    <div className="p-6 max-w-[1400px] mx-auto" data-testid="kpis-presentaciones">
      <div className="mb-6">
        <div className="flex items-center gap-2 text-indigo-600 mb-1">
          <FileStack size={20} />
          <span className="text-xs font-semibold uppercase tracking-wide">Presentaciones AFIP</span>
        </div>
        <h1 className="text-2xl font-bold text-slate-800">Presentaciones</h1>
        <p className="text-sm text-slate-500 mt-1">
          Estado de las presentaciones de acuses de AFIP, catalogadas por CUIT informante y formulario.
        </p>
      </div>
      <PresentacionesTab />
    </div>
  );
}
